<template>
  <b-modal
    id="show-domains-template-info-modal"
    :title="$t('label.domain')"
    scrollable
    hide-footer>
    <center>{{ template.label }}</center>
    <b-table 
      :fields="fields"
      :items="template.domains">
      <template #cell(patgames)="row">
        <b-badge style="margin: 1px" v-for="(id, pos) in row.item.patgames" :key="'patgames-' + pos">{{ getPatgamesLabel(id) }}</b-badge>
      </template>
    </b-table>
  </b-modal>
</template>

<script>
import { getPatgames } from '../services/patgames';

export default {
  props: {
    establishment: {
      type: Object,
      required: true,
    }
  },
  computed: {
    fields() {
      return [
        {
          label: {
            label: this.$t('label.domain_name'),
            sortable: true,
          }
        },
        {
          patgames: {
            label: 'PATGames',
            sortable: false,
          }
        },
      ] 
    },
  },
  data() {
    return {
      template: [],
      modules: []
    };
  },
  async mounted() {
    this.modules = await getPatgames(this.establishment.esta_id);
  },
  methods: {
    show(template) {
      this.template = template;
      this.$bvModal.show("show-domains-template-info-modal")
    },
    hide() {
      this.$bvModal.hide("show-domains-template-info-modal")
    },
    getPatgamesLabel(id) {
      return this.modules.find(m => m.act_id === id)?.act_label
    }
  }
}
</script>